import {DomElement,svgIcons,convert2d3d} from '../../types/datatypes'

const iconlist=Object.keys(svgIcons)


class ImgElement extends DomElement{
  createDom(){
    var container=this.createContainer()
    var html=`<img class="value" src=`+this.params.value+` style="width:`+this.params.width+`px;height:`+this.params.height+`px">`
    container.innerHTML=html
    return container
  }
}
const dom=new ImgElement('img','图片')
dom.params={
  name:'',
  value:'',
  use3d:false,
  width:32,
  height:32,
  setting:['namevalue','xyz']
}
dom.format={
  name:{name:'名称',change(mesh,v){ }},
  value:{name:'图片地址', change(mesh,v){
    mesh.element.querySelector('.value').setAttribute('src',v)
  }},
  width:{name:'宽',change(mesh,v){
     mesh.element.querySelector('.value').style.width=v+'px'
  }},
  height:{name:'高',change(mesh,v){
     mesh.element.querySelector('.value').style.height=v+'px'
  }},
  use3d:{name:'3d对象',domtype:'switch',change(mesh,v){
       convert2d3d(mesh,v)
  }}
}
export default dom
